var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackdropup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9425 1.14109C5.99083 1.18818 6.1975 1.36597 6.3675 1.53158C7.43667 2.50252 9.18667 5.0354 9.72083 6.3611C9.80667 6.56243 9.98833 7.07144 10 7.3434C10 7.60399 9.94 7.85241 9.81833 8.08946C9.64833 8.38497 9.38083 8.62202 9.065 8.75191C8.84583 8.83553 8.19 8.96542 8.17833 8.96542C7.46083 9.09531 6.295 9.16675 5.00667 9.16675C3.77917 9.16675 2.66083 9.09531 1.9325 8.98896C1.92083 8.97678 1.10583 8.84689 0.826667 8.70482C0.316667 8.44423 1.07664e-07 7.93522 1.55286e-07 7.39048L1.59402e-07 7.3434C0.0125 6.98863 0.329168 6.24257 0.340834 6.24257C0.875834 4.98831 2.54 2.51388 3.64583 1.5194C3.64583 1.5194 3.93 1.23932 4.1075 1.11755C4.3625 0.927585 4.67833 0.833414 4.99417 0.833414C5.34667 0.833414 5.675 0.939763 5.9425 1.14109Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackdropup);
export default __webpack_public_path__ + "static/media/blackdropup.fda164159d4494fe9eef42b02d63e66d.svg";
export { ForwardRef as ReactComponent };